import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { DetailRoutingModule } from './detail-routing.module';
import { AmRewardsPricingComponent } from '@am/rewards-pricing';
import { AmTripsAddProductModule } from '@am/trips-add-product';
// Todo: add this module: import { AmExpertsReviewCarouselModule } from '@am/experts-review-carousel';

// Container
import { DetailComponent } from './detail.component';

// Components Detail
import { DetailComponentsModule } from './components/detail.module';
import { MbIconModule } from '@am/moebius';
import { Ga4Service } from '@core/services/ga4.service';
import { RouterModule } from '@angular/router';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        SharedModule,
        DetailRoutingModule,
        MbIconModule,
        AmRewardsPricingComponent,
        AmTripsAddProductModule,
        DetailComponentsModule,
        RouterModule,
        DetailComponent,
    ],
    exports: [DetailComponentsModule],
    providers: [Ga4Service],
})
export class DetailModule {}
